<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div *ngIf="!parentData.data">
      <mat-form-field appearance="outline">
        <mat-label>Subject</mat-label>
        <input
          [(ngModel)]="queryData.subject"
          matInput
          #input
        />
       
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          [(ngModel)]="queryData.description"
          matInput
        ></textarea>
       
      </mat-form-field>
    </div>
    <!-- <input type="text" placeholder="Enter name" /> -->
    <div style="display: flex; justify-content: center; align-items: center">
      <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner>
    </div>
    <div *ngIf="assetList.length > 0" class="row" style="justify-content: space-evenly;">
      <div *ngFor="let asset of assetList; let i = index" class="image-preview"  style="position: relative;    width: fit-content;    margin-bottom: 20px;    border: 1px solid lightgray;
        padding: 15px;
    ">
        <div >
          <img [src]="asset.file_url" alt="" style="width: 200px; height: 170px; object-fit: cover;">
          <span (click)="removeAsset(i)" style="position: absolute;
          cursor: pointer;
          top: 0;
          right: 0;
          background: #dd2c00;
          border-radius: 50%;
          height: 30px;
          width: 30px;" ><mat-icon style="    position: absolute;
        left: 3px;
        top: 2px;
        color: white;" class="material-icons-outlined">close</mat-icon></span>
        </div>
     
      </div>
    </div>
   
    <div class="upload-group mb-2" *ngIf="assetList.length == 0">
      <label for="formFile" class="form-label">Upload media</label>
      <div class="file-input-wrap">
        <div class="custom-input-label">
          <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
            >backup</mat-icon
          >
          <p>Drop your file(s) here or <span>browse</span></p>
        </div>
        <input
      
          class="form-control"
          id="formFile"
          accept="image/*"
          type="file"
          
          (change)="onUploadImage($event)"
        />
      </div>
      <!-- <mat-chip-list #chipList style="margin-top: 2px">
        <mat-chip style="width: 100%; padding: 10px">File</mat-chip>
      </mat-chip-list> -->
    </div>

<div class="add_more_sd" *ngIf="assetList.length > 0">
  <button (click)="triggerFileInput()" mat-stroked-button  > <mat-icon style="position: relative; top: -2px;">add</mat-icon> Add More</button>
</div>
<input type="file" #additionalFileInput style="display: none;" (change)="onUploadImage($event)" accept="image/*" />



  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      (click)="submitQuery()"
    >
      Submit
    </button>
  </mat-dialog-actions>
  